const { getIcon } = require("utils/iconsConfig");

const Project_Icons = {
  "Binny’s Vision Role": getIcon("Vision_Project_Icon"),
  "Binny’s Select Role": getIcon("Select_Project_Icon"),
  "Binny’s Create Role": getIcon("Create_Project_Icon"),
};

export const getProjectIcon = (projectName) => {
  return Project_Icons[projectName] || null;
};
